import LicenseKeyForm from "../LicenseKeyForm";

export const LicenseKeyAdd = (): JSX.Element => {
  return <LicenseKeyForm />;
};

export default LicenseKeyAdd;
